<template>
  <v-container fluid class="todo-list">
    <patient-header />
    <!--    <v-list two-line subheader>-->
    <!--      <v-list-item>-->
    <!--        <v-list-item-content>-->
    <!--          <v-list-item-title>-->
    <!--            <v-text-field v-model="newTodo" id="newTodo" name="newTodo" label="Добавьте задание" @keyup.enter="addTodo" />-->
    <!--          </v-list-item-title>-->
    <!--        </v-list-item-content>-->
    <!--      </v-list-item>-->
    <!--    </v-list>-->

    <v-progress-linear v-if="loadingList" indeterminate></v-progress-linear>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left" width="34px"></th>
            <th class="text-left">Название параметра</th>
            <th class="text-left">Значения</th>
            <th class="text-left" width="200px"></th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(group, groupIdx) in groups">
            <tr :key="`group-name-${groupIdx}`">
              <td colspan="4">
                <v-subheader class="font-weight-bold text-h4 pl-0">{{ group.name }}</v-subheader>
              </td>
            </tr>
            <tr v-for="(task, taskIdx) in group.items" :key="`group-${groupIdx}-task-${taskIdx}`">
              <td>
                <v-checkbox :value="task.ui_done" disabled></v-checkbox>
              </td>
              <td>{{ task.name }}</td>
              <td>
                <template v-if="isSymptom(group.code) || isReminder(group.code)">
                  <v-btn-toggle
                    class="task-value-toggler"
                    tile
                    group
                    :value="task.value"
                    @change="updateTask($event, group, task)"
                  >
                    <v-btn :value="true">Было</v-btn>
                    <v-btn :value="false">Не было</v-btn>
                  </v-btn-toggle>
                </template>

                <template v-else-if="isReminderDoctor(group.code)">
                  <v-btn
                    :to="{
                      name: 'appointment',
                      query: { eventId: task.id, minDate: task.start_at, specialization: task.entity_id },
                    }"
                    color="primary"
                  >
                    Записаться
                  </v-btn>
                </template>

                <template v-else>
                  <v-text-field
                    type="number"
                    label="Значение"
                    class="mt-0 pt-0"
                    :loading="task.ui_saving"
                    :readonly="task.ui_done"
                    :suffix="task.measure"
                    :value="task.value"
                    @blur="updateTask($event.target.value, group, task)"
                  >
                    <template #progress>
                      <v-progress-linear indeterminate absolute height="2"></v-progress-linear>
                    </template>
                  </v-text-field>
                </template>
              </td>
              <td>
                <v-btn
                  v-if="group.code !== 'reminder_doctor'"
                  color="green darken-1"
                  text
                  :disabled="!task.ui_done"
                  @click="deleteTaskValue(task)"
                >
                  Сброс значения
                </v-btn>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </v-container>
</template>

<script>
import { TaskGroups } from "@/modules/tasks/tasks.config.js";
import { groupBy } from "@/services/utils.js";
import { TasksResultRepository } from "@/modules/tasks/tasks-result.repository.js";
import PatientHeader from "@/components/PatientHeader";
export default {
  name: "TasksResults",
  components: { PatientHeader },
  data() {
    return {
      loadingList: false,
      measuresList: new Map(),
      groups: [],
    };
  },
  computed: {},

  async created() {
    try {
      const { data } = await this.$http.get(`v1/measures`);
      if (!(data?.data || []).length) {
        return;
      }

      const measures = new Map();
      data.data.forEach(item => {
        measures.set(item.id, item);
      });

      this.measuresList = measures;
    } catch (e) {
      this.$dialog.notify.error("Ошибка загрузки списка измерений");
    }

    await this.loadListData();
  },

  methods: {
    async loadListData() {
      try {
        this.loadingList = true;
        const { data } = await this.$http.get(`/v1/customers/${this.$store.state.customer.id}/events/agenda`);

        if (!data?.data.length) {
          return;
        }

        const listData = {};
        const types = groupBy("entity_type")(data.data);
        console.log("types", types);
        for (const typeKey in types) {
          const listItem = {
            name: this.$i18n.t(`tasks.types.${typeKey}`),
            code: typeKey,
            items: [],
          };

          types[typeKey].forEach(typeItem => {
            const entityPayload = JSON.parse(typeItem.entity_payload);

            /**
             * @type {TaskEventItem} item
             */
            const item = {
              id: typeItem.id,
              name: entityPayload.title,
              value: typeItem.result,
              measure: this.measuresList.has(entityPayload.measure_id)
                ? this.measuresList.get(entityPayload.measure_id).name
                : "",
              comment: null,
              completed: null,
              ui_done: false,
              ui_saving: false,
              ui_input_type: this.getUiInputType(entityPayload.ui_input_type || ""),
            };

            if (typeKey === TaskGroups.reminder_doctor) {
              item.start_at = typeItem.start_at;
              item.entity_id = typeItem.entity_id ? Number(typeItem.entity_id) : null;
            }

            listItem.items.push(item);
          });

          listData[typeKey] = listItem;
        }

        this.groups = listData;
      } catch (e) {
        console.error(e);
        this.$dialog.notify.error("Ошибка загрузки заданий");
      } finally {
        this.loadingList = false;
      }
    },

    isSymptom(code) {
      return code === TaskGroups.symptom;
    },

    isReminder(code) {
      return code === TaskGroups.reminder;
    },

    isReminderDoctor(code) {
      return code === TaskGroups.reminder_doctor;
    },

    /**
     * @param {*} val
     * @param {object} group
     * @param {TaskEventItem} task
     * @returns {Promise<void>}
     */
    async updateTask(val, group, task) {
      if (val === "" || val === null) {
        return;
      }

      task.value = val;
      let taskValue = val;

      if (typeof val === "boolean") {
        taskValue = val ? "1" : "0";
        task.value = val;
      }

      task.ui_done = true;
      task.ui_saving = true;

      TasksResultRepository.updateValue(this.$store.state.customer.id, {
        id: task.id,
        value: taskValue,
        comment: null,
        completed: null,
      })
        .then(response => {
          console.log("updateValue", response);
          this.$dialog.notify.success(`Измерение успешно добавлено`);
        })
        .catch(e => {
          console.error(e);
          this.$dialog.notify.error("Ошибка добавления измерения");
        })
        .finally(() => {
          task.ui_saving = false;
        });
    },

    async deleteTaskValue() {
      this.$dialog.info({ title: "Удаление значения задания", text: "Функционал в разработке" });
    },

    /**
     * @param {string} type
     */
    getUiInputType(type) {
      if (["int", "integer", "float"].includes(type)) {
        return "number";
      }

      if ("string" === type) {
        return "text";
      }

      return "number";
    },
  },
};
</script>
<style lang="scss">
.task-value-toggler {
  .v-btn {
    margin-left: 0 !important;

    .v-btn__content {
      color: #000;
    }

    &.v-item--active {
      background: #999 !important;
      color: #fff !important;

      .v-btn__content {
        color: #fff;
      }
    }
  }
}

.todo-list {
  .v-list-item__action,
  .v-list-item__content {
    align-self: flex-start;
  }
}

.todo-list-item {
  &__value,
  &__form {
    width: 300px;
    flex-shrink: 0;
  }

  &__value {
  }
}
</style>
